import React from 'react';
import { Box, Typography, TypographyProps } from '@material-ui/core';

const fontWeights: { [key: string]: string } = {
  bold: 'fontWeightBold',
  medium: 'fontWeightMedium',
  regular: 'fontWeightRegular',
};

interface IText extends TypographyProps {
  fontWeight?: string;
}

const Text = React.memo(
  ({
    variant = 'body1',
    color = 'textPrimary',
    className,
    fontWeight = 'regular',
    children,
    align,
  }: IText) => {
    const fontWeightSelected = fontWeights[fontWeight] ?? fontWeights.regular;

    return (
      <Typography
        variant={variant}
        color={color}
        className={className}
        component="div"
        align={align}
      >
        <Box fontWeight={fontWeightSelected}>{children}</Box>
      </Typography>
    );
  }
);

export default Text;
